import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const cache = new Map();

/** Tiny GET hook with in-memory cache. Returns {data, error, loading}. */
export function useFetch(path, params) {
  const key = path ? path + JSON.stringify(params || {}) : null;
  const [state, setState] = useState(() => ({ data: key ? cache.get(key) : undefined, error: null, loading: !!key && !cache.has(key) }));
  useEffect(() => {
    if (!key) return;
    let live = true;
    setState((s) => ({ data: cache.get(key), error: null, loading: !cache.has(key) }));
    api.get(path, { params }).then((r) => {
      cache.set(key, r.data);
      live && setState({ data: r.data, error: null, loading: false });
    }).catch((e) => live && setState({ data: undefined, error: e, loading: false }));
    return () => { live = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return state;
}
